<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="DisposalRecordsId"
      ref="list"
      unit="设备处置记录"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/facility/dispose/list.json";
import tableParam from "@/data/facility/dispose/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/disposalRecords").default,
      params: {
        JobName: "",
        Status: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>